module.exports = __webpack_public_path__ + "static/media/Artboard8.ebefa3e7.png";